export const EventConnected = 'connected';
export const EventConnectionError = 'connectionError';
export const EventDisconnected = 'disconnected';
export const EventMessage = 'message';
export const DefaultStorageKeyPrefix = 'ipc';
export const DefaultStorageExpiredTime = 30000;
